module.exports = {
      id: "tomato-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#tomato",
      toString: function () {
        return this.url;
      }
    }